export default "__VITE_ASSET__u6TUxNKQ__"